import { FluidTheme } from '@lmig/fluid-core';
import { FunctionalComponent, h } from '@stencil/core';

import { CollapseToggle } from '../../../../common/fluid-common-button.components';

interface ContextBarProps {
  togglePanel?: () => void;
  panelCollapsed?: boolean;
  theme?: FluidTheme;
  hasPanelSlot?: boolean;
}

// ================================================================ //
// -- Public Functional Components

/**
 * ContextBarBody - Main Content Container
 */
export const ContextBarBody: FunctionalComponent<ContextBarProps> = (
  props: ContextBarProps
) => {
  const { hasPanelSlot, panelCollapsed, theme, togglePanel } = props;

  return (
    <div
      class={{
        'context-bar-body': true,
        'panel-expanded': !panelCollapsed,
      }}>
      <div class='body-content'>
        <slot />
      </div>
      {hasPanelSlot && (
        <CollapseToggle
          toggleCollapsed={togglePanel}
          collapsed={panelCollapsed}
          theme={theme}
        />
      )}
    </div>
  );
};

/**
 * ContextBarPanel - Expandable Panel
 */
export const ContextBarPanel: FunctionalComponent<ContextBarProps> = (
  props: ContextBarProps
) => {
  const { hasPanelSlot, panelCollapsed } = props;

  if (!hasPanelSlot) return;

  return (
    <div
      class={{
        'context-bar-panel-container': true,
      }}>
      <div
        class={{
          'context-bar-panel': true,
          'panel-expanded': !panelCollapsed,
        }}>
        <div
          class={{
            'panel-content-container': true,
            'content-visible': !panelCollapsed,
          }}>
          <div class='panel-content'>
            <slot name='context-panel'></slot>
          </div>
        </div>
      </div>
    </div>
  );
};
